import { toast, ToastContainer } from 'react-toastify'
import { useTranslation } from 'react-i18next';
import LandPage from '../../../Component/common/LandPage/LandPage'
import Navbar from '../../../Component/common/Navbar/Navbar'
import Topbar from '../../../Component/common/Topbar/Topbar'
import TwoInputs from '../../../Component/common/TwoInputs/TwoInputs'
import Footer from '../../../Component/common/Footer/Footer';
import './FastBooking.css'
function FastBooking(){
  const { t } = useTranslation();
  const token = localStorage.getItem("token")

  const sendForm = (e)=>{
    e.preventDefault()
    if(!token){
      toast.error(t('plsLoginFirst'))
      return
    }
    toast.success(t('formSent'))
  }
  return(
    <>
      <Topbar/>
      <Navbar/>
      <LandPage
        header={t('fastBooking')}
        link={t('fastBooking')}
        href='/fast-booking'
        />
        <ToastContainer/>
      <div className="fastBooking-container container">
        <div className="fastBooking-content content">
          <h2 className='h-after-effect'>{t('pleaseFillForm')}</h2>
          <form>
            <TwoInputs typeOne={"text"} placeOne={t('name')} typeTwo={"number"} placeTwo={t('mobileNumber')}/>
            <div className="twoInputs">
              <input type="date" placeholder='f,' />
            </div>
            <textarea placeholder={t('writeReason')} ></textarea>
            <textarea placeholder={t('writeNotes')} ></textarea>
            <button className='addBtn' onClick={(e)=>sendForm(e)}>{t('send')}</button>
            <p>{t('confirmWithinTwoHours')}</p>
          </form>
        </div>
      </div>
      <Footer/>
    </>
  )
}
export default FastBooking